var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1=" <div class=\"frame-header\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-xs-12 col-sm-6 service-logo-block\" id=\"service-logo-block\"> <a ng-click=\"toService()\" aria-label=\"{{ 'MAIN.ACCESSIBILITY.SERVICE_LOGO_ARIA' | translate }} {{pay.data.searchServices.name}}\"><img src=\"{{pay.data.searchServices.icon}}\" alt=\"{{pay.data.searchServices.name}} {{ 'MAIN.ACCESSIBILITY.LOGO_ALT' | translate }}\"></a> </div> <div class=\"col-xs-12 col-sm-6 phub-logo-block\"> <a ui-sref=\"pages.registration\" target=\"_blank\" ng-click=\"goTop()\" aria-label=\"{{ 'MAIN.ACCESSIBILITY.REGISTRATION_LOGO_ARIA' | translate }}\"> <img src=\"" + require("../images/logo.png") + "\" height=\"70\" alt=\"{{ 'MAIN.ACCESSIBILITY.LOGO_ALT' | translate }}\"> </a> </div> </div> </div> </div> ";
ngModule.run(["$templateCache",function(c){c.put("frameHeader/templates/header.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameHeader/templates/header.html
 ** module id = 580
 ** module chunks = 1
 **/